export default __webpack_public_path__ + "static/media/emailsuccess.d4bbc6c1.png";